import {
  assign,
  createMachine,
  ErrorPlatformEvent,
  Interpreter,
  spawn,
  Actor,
} from 'xstate-v4'
import { rootContainer } from '~/container'
import sentryCapture from '~/utility/sentryCapture'
import { PaymentCard } from '../schema'

interface UserStoredCardsContext {
  cards: Record<string, Actor>
  cardMachine: any
}

interface UserStoredCardsEvent {
  type: 'REMOVE'
  cardId: string
}

export function returnUserStoredCardsMachine() {
  return createMachine<UserStoredCardsContext, UserStoredCardsEvent>(
    {
      context: {
        cards: {},
        cardMachine: {},
      },
      initial: 'initializing',
      states: {
        initializing: {
          invoke: {
            src: 'getCards',
            onDone: {
              target: 'showing',
              actions: assign({
                cards: (ctx, { data }) => {
                  return (data as PaymentCard[]).reduce((accumulator, card) => {
                    accumulator[card.id] = spawn(
                      ctx.cardMachine.withContext(card),
                    )
                    return accumulator
                  }, {})
                },
              }),
            },
            onError: {
              target: 'error',
              actions: 'logError',
            },
          },
        },
        showing: {
          on: {
            REMOVE: {
              actions: assign({
                cards: (ctx, event) => {
                  const amendedCards = { ...ctx.cards }
                  delete amendedCards[event.cardId]
                  return amendedCards
                },
              }),
              internal: true,
            },
          },
        },
        error: {
          type: 'final',
        },
      },
    },
    {
      actions: {
        logError: (_, _event: any) => {
          const event: ErrorPlatformEvent = _event
          event.data.name = `userStoredCardsMachine ${event.type} error`
          sentryCapture(event.data, rootContainer)
        },
      },
    },
  )
}
export type UserStoredCardsMachineInterpreter = Interpreter<
  UserStoredCardsContext,
  any,
  UserStoredCardsEvent
>
